module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.23.0@babel-runtime/core-js/get-iterator.js
 ** module id = 650
 ** module chunks = 0 1
 **/